import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

interface DropdownMenuItemProps {
    $destructive?: boolean;
}

export const DropdownMenuItem = styled(RadixDropdownMenu.Item)<DropdownMenuItemProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    color: ${(props) => (props.$destructive ? theme.colors.negative.foreground : theme.colors.accent.foreground)};
    padding: ${theme.space[4]} ${theme.space[8]};
    outline: none;
    cursor: pointer;
    border-radius: ${theme.radii[4]};

    &:hover {
        background: ${(props) =>
            props.$destructive ? theme.colors.negative.background : theme.colors.accent.background};
    }

    &[data-disabled] {
        pointer-events: none;
        color: ${theme.colors.foreground.disabled};
    }
`;
